import { Card, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  children: React.ReactNode | React.ReactNode[];
}

const CardWrapper: React.FC<Props> = ({ children, title }: Props) => {
  return (
    <Card
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        borderRadius: 2,
        height: 'auto',
        padding: {
          mobile: '16px',
          tablet: '40px',
        },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: 700,
          lineHeight: { mobile: '32px', tablet: '40px' },
          fontSize: {
            mobile: '23px',
            tablet: '28px',
          },
          marginBottom: '24px',
        }}
      >
        {title}
      </Typography>
      {children}
    </Card>
  );
};

export default CardWrapper;
